// app/components/SuvatSliderNoSSR.tsx
"use client";

import LazyHydrate from "@/app/components/LazyHydrate";
import Spinner from "@/app/components/Spinner";

/**
 * SUVAT slider + Plotly is ~140 kB after the “lite” bundle-split.
 * LazyHydrate keeps that code off the main route until the user
 * scrolls within 600 px of the placeholder.
 */
export default function SuvatSlider() {
  return (
    <LazyHydrate
      loader={() => import("@/app/components/SuvatSliderPlotly")}
      rootMargin="600px" // pre-load a little before it appears
      threshold={0} // fire as soon as any pixel is visible
      fallback={<Spinner />}
    />
  );
}
